module.exports = __webpack_public_path__ + "img/walk-icon.aa39d766.svg";